import React, { useState, useEffect, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import DashboardLayout from "./DashboardLayout";
import { getComplaintGroup, addComplaint } from "../services/ComplaintsService";
import { CustomerContext } from "../context/customerContext";
import { toast } from "react-toastify";


const ComplaintsRequest = () => {
  const navigate = useNavigate();

  const [group, setGroup] = useState([]);
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const { customer } = useContext(CustomerContext);

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const response = await getComplaintGroup();
        if (Array.isArray(response.data)) {
          setGroup(response.data);
        } else {
          console.warn("خروجی غیرمجاز:", response.data);
        }
      } catch (error) {
        console.error("خطا در دریافت دسته‌بندی شکایات:", error);
      }
    };

    fetchGroups();
  }, []);

  const handleSubmit = async (e) => {

    e.preventDefault();

    if (category === "") {
      toast.error("لطفاً دسته‌بندی موضوع انتخاب کنید.");
      return;
    }

    if (!customer?.customerId) {
      toast.error("شناسه مشتری یافت نشد.");
      return;
    }


    const complaintData = {
      complaintGroupId: parseInt(category), // groupId باید عدد باشه
      request: description,
      customerPartyRef: customer.partyRef,
      createDate: new Date().toISOString().split(".")[0],
      complaintStatusId: 1, // فرض: وضعیت اولیه "در حال بررسی"
    };
    try {
      const response = await addComplaint(complaintData);
      const toastId = toast.success("درخواست شما با موفقیت ثبت شد.", {
        autoClose: 2000,
        onClose: () => {
          // فقط بعد از اینکه toast بسته شد، navigate کن
          navigate("/complaints-list");
        },
      });
      setCategory("");
      setDescription("");
    } catch (error) {
      console.error("❌ خطا در ثبت شکایت:", error);
      toast.error(" خطا در ثبت شکایت!");
    }
  };

  return (
    <DashboardLayout>
      <div className="flex items-center justify-between px-6 mb-4">
        <h1 className="text-base sm:text-lg md:text-xl  font-bold text-blue-700">
          ثبت اعلانات و شکایات
        </h1>
        <button
          onClick={() => navigate(-1)}
          className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded"
        >
          بازگشت
        </button>
      </div>



      <form onSubmit={handleSubmit} className="px-6 space-y-4">
        <div>
          <label className="block mb-1 text-sm font-medium">
            دسته بندی موضوع *
          </label>
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="w-full border px-3 py-2 rounded focus:outline-none focus:ring"
          // required
          >
            <option value="">انتخاب کنید</option>
            {group.map((g) => (
              <option key={g.id} value={g.id}>
                {g.name}
              </option>
            ))}
          </select>
        </div>

        {/* <div>
          <label className="block mb-1 text-sm font-medium">موضوع شکایت</label>
          <input
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            className="w-full border px-3 py-2 rounded focus:outline-none focus:ring"
            placeholder="موضوع درخواست"
            required
          />
        </div> */}

        <div>
          <label className="block mb-1 text-sm font-medium">شرح موضوع</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="w-full border px-3 py-2 rounded focus:outline-none focus:ring"
            rows="4"
            placeholder="شرح کامل اعلانت و شکایات ..."
          // required
          />
        </div>

        <div className="text-left">
          <button
            type="submit"
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
          >
            ثبت درخواست
          </button>
        </div>
      </form>
    </DashboardLayout>
  );
};

export default ComplaintsRequest;
